import { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export function TabularNumber({ children, className = '', size = 'md' }: Props) {
  const sizeCls = size === 'sm' ? 'text-sm' : size === 'lg' ? 'text-2xl' : size === 'xl' ? 'text-4xl' : 'text-base';
  return <span className={`num ${sizeCls} ${className}`}>{children}</span>;
}
